import { toRem } from "../../../helpers/theme";

const Style = ({ theme }) => ({
    display: "flex",
    marginBottom: toRem(20),
    alignItems: "center",
    fontSize: toRem(16),
    lineHeight: 1.4,
    color: theme.colors.black,
    "& .link": {
        display: "block",
        width: "100%",
        textDecoration: "none",
        color: "inherit",
        "&:hover": {
            color: theme.colors.gray500,
        },
    },
    "& .content": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        "&:hover": {
            color: theme.colors.gray500,
            svg: {
                path: {
                    fill: theme.colors.gray500,
                },
            },
        },
    },
    "& .image": {
        display: "inline-block",
        width: toRem(40),
        height: toRem(40),
        marginRight: toRem(15),
    },
    // '& .title': {},
    "& .iconWrapper": {
        marginLeft: "auto",
    },
});

export default Style;
